import { makeApi } from "@zodios/core";
import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";
import { escAcquisitionEligibilityResponseDto } from "@/types/backoffice/dto/esc/esc-acquisition-eligibility-response-dto.ts";
import { escAcquisitionStateResponseDtoSchema } from "@/types/backoffice/dto/esc/esc-acquisition-state-response-dto.ts";
import { escFolderAggregateSchema } from "@/types/backoffice/dto/esc/esc-folder-aggregate-dto.ts";
import { escNonEligibilityReportDtoSchema } from "@/types/backoffice/dto/esc/esc-non-eligibility-report-dto";

export const backofficeEscApi = makeApi([
  {
    method: "get",
    path: "/site/:siteId/acquisition-esc-eligibility",
    response: escAcquisitionEligibilityResponseDto,
    alias: "getESCAcquisitionEligibility",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: branded.siteId,
      },
    ],
  },
  {
    method: "get",
    path: "/site/:siteId/esc-state",
    response: escAcquisitionStateResponseDtoSchema,
    alias: "getESCAcquisitionState",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: branded.siteId,
      },
    ],
  },
  {
    method: "put",
    path: "/site/:siteId/validate",
    response: z.any(),
    alias: "validateEsc",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: branded.siteId,
      },
    ],
  },
  {
    method: "post",
    path: "/sign/:signatureId/regenerate",
    response: z.any(),
    alias: "regenerateEscSignatureRequest",
    parameters: [
      {
        type: "Path",
        name: "signatureId",
        schema: branded.escSubscriberSignatureId,
      },
    ],
  },
  {
    method: "post",
    path: "/sign/:siteId/upgrade-signature-to-esc",
    response: z.any(),
    alias: "upgradeSignatureToEsc",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: branded.siteId,
      },
    ],
  },
  {
    method: "get",
    path: "/site/:siteId/eligibility-criteria",
    response: escNonEligibilityReportDtoSchema,
    alias: "getEligibilityCriteria",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: branded.siteId,
      },
    ],
  },
  {
    method: "put",
    path: "/site/:siteId/eligibility-criteria/update",
    response: z.void(),
    alias: "putEligibilityCriteria",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: branded.siteId,
      },
      {
        type: "Body",
        name: "body",
        schema: escNonEligibilityReportDtoSchema,
      },
    ],
  },
  {
    method: "get",
    path: "/folder/site/:siteId/subscriber/:subscriberId",
    response: escFolderAggregateSchema,
    alias: "getEscFolder",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: branded.siteId,
      },
      {
        type: "Path",
        name: "subscriberId",
        schema: branded.subscriberId,
      },
    ],
  },
]);
